const SET_SCHEDULINGTYPE = 'setSchedulingType'
const SET_SCHEDULINGTYPES = 'setSchedulingTypes'

export const mutationTypes = {
  SET_SCHEDULINGTYPE,
  SET_SCHEDULINGTYPES
}

export const mutations = {
  [SET_SCHEDULINGTYPE] (state, payload) {
    state.schedulingtype = payload
  },

  [SET_SCHEDULINGTYPES] (state, payload) {
    state.schedulingtypes = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/module/schedulingtype/mutations.js